<p-confirmPopup></p-confirmPopup>

<p-table [value]="comments" [autoLayout]="true" styleClass="p-datatable-sm" 
	(onEditInit)="onEditInit($event)" (onEditCancel)="onEditCancel($event)" (onEditComplete)="onEditComplete($event)">
	<ng-template *ngIf="!readOnlyUser" pTemplate="header">
		<tr *ngIf="comments[0]?.id">
			<th colspan="2" class="p-text-light p-text-italic p-text-center">
				{{headerMessage}}
			</th>
		</tr>
	</ng-template>

	<ng-template pTemplate="body" let-comment let-rowIndex="rowIndex">
		<tr>
			<td *ngIf="!readOnlyUser && comment.createdBy.id == userId; else nonEditable" class="comment"
				[pEditableColumn]="comment" [pEditableColumnField]="comment.comment" [pEditableColumnRowIndex]="rowIndex">
				<p-cellEditor>
					<ng-template pTemplate="input">
						<textarea pInputTextarea [(ngModel)]="comment.comment" rows="4" (focusout)="onTextareaFocusOut($event)"
							(keydown.enter)="$event.stopPropagation()"
							(keydown.arrowup)="$event.stopPropagation()"
							(keydown.arrowdown)="$event.stopPropagation()"
							(keydown.arrowleft)="$event.stopPropagation()"
							(keydown.arrowright)="$event.stopPropagation()">
						</textarea>

						<ng-container *ngTemplateOutlet="ct; context: { $implicit:comment }"></ng-container>
					</ng-template>

					<ng-template pTemplate="output">
						<p>{{comment.comment}}</p>

						<ng-container *ngTemplateOutlet="ct; context: { $implicit:comment }"></ng-container>
					</ng-template>
				</p-cellEditor>
			</td>

			<ng-template #nonEditable>
				<td>
					<p>{{comment.comment}}</p>

					<ng-container *ngTemplateOutlet="ct; context: { $implicit:comment }"></ng-container>
				</td>
			</ng-template>

			<td *ngIf="!readOnlyUser">
				<button *ngIf="role == 'ADMIN' || (role == 'WRITE' && comment.createdBy.id == userId)"
					pButton pRipple icon="pi pi-trash" (click)="onDeleteClicked(comment, rowIndex, $event)" 
					class="p-button-rounded p-button-text p-button-danger" title="Delete Comment">
				</button>
			</td>
		</tr>
	</ng-template>

	<ng-template *ngIf="!readOnlyUser" pTemplate="footer">
        <tr>
            <td colspan="2" class="p-text-right p-py-0">
				<button pButton label="Enter New Comment" class="p-button-link" (click)="onNewCommentClicked()"></button>
			</td>
        </tr>
    </ng-template>
</p-table>

<ng-template #ct let-comment>
	<div *ngIf="comment.id" class="p-d-flex p-jc-between">
		<span class="p-text-light">
			by {{comment.createdBy.firstName}} {{comment.createdBy.lastName}}
		</span>

		<span class="p-text-light">
			Updated {{comment.updated | date: 'MM/dd/yyyy HH:mm' }}
		</span>
	</div>
</ng-template>